import BancaFarmaci from"../"

const routes = [
  {
    name: 'BancaFarmaciListPage',
      path: '/bancafarmaci',
      component: BancaFarmaci.BancaFarmaciListPage,
  },
  {
    name: "BancaFarmaciView",
    path: "/bancafarmaci/view/:id",
    component: BancaFarmaci.BancaFarmaciViewPage,
    meta: { title: "Banca Farmaci - View" },
  },
];
export default routes;